import { useEffect } from "react";
import {
  getDigitalProfileUrl,
  redirectToDigitalProfile,
} from "../../../utils/digitalProfile";

const ManageAccount = () => {
  useEffect(() => {
    redirectToDigitalProfile();
  }, []);

  const profileUrl = getDigitalProfileUrl();

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "32rem",
          borderRadius: "16px",
          background: "#fff",
          padding: "32px",
          textAlign: "center",
          boxShadow: "0 12px 32px rgba(23, 43, 31, 0.08)",
        }}
      >
        <h2 style={{ margin: "0 0 8px", fontSize: "1.5rem", color: "#111" }}>
          Manage Account
        </h2>
        <p style={{ margin: "0 0 24px", fontSize: "0.9rem", color: "#5f6b63" }}>
          Profile, company logo, and security settings are managed on GE3S Digital.
          Updates there will appear across your Sustainability Index workspace.
        </p>
        <a
          href={profileUrl}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "12px",
            background: "#02b880",
            color: "#fff",
            padding: "12px 20px",
            fontWeight: 700,
            textDecoration: "none",
          }}
        >
          Open GE3S Digital Profile
        </a>
      </div>
    </div>
  );
};

export default ManageAccount;
